<div class="modal-content">
  <div class="modal-header">
      <h5 class="modal-title" id="cs-cd-modal-header-id"><b>{{modalData.title}}</b></h5>
      <button type="button" class="close" (click)="onClose()" aria-label="Close" id="cs-cd-button-close-form-id">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body">
      <p>{{modalData.notifyMessage}}</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btnClose close-button" (click)="onClose()" id="cs-cd-button-cancel-id">{{modalData.nameButtonCancel}}</button>
      <button type="button" class="btn btn-primary btnSaveClose save-close-button" (click)="onConfirm()" id="cs-cd-button-save-id">{{modalData.nameButtonAction}}</button>
  </div>
</div>
